<template>
  <div class="tw-px-4 tw-py-2">
    <label v-if="label" class="tw-block tw-text-xs tw-font-medium tw-text-nc-text-secondary tw-mb-1.5">{{ label }}</label>
    <input
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      class="tw-w-full tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-border tw-outline-none tw-transition-colors placeholder:tw-text-nc-text-placeholder"
      :class="inputClasses"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <p v-if="error" class="tw-text-xs tw-text-nc-danger tw-mt-1">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'NcInput',
  props: {
    modelValue: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    error: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    inputClasses() {
      if (this.readonly || this.disabled) {
        return 'tw-bg-nc-bg-page tw-border-nc-border tw-text-nc-text-secondary tw-cursor-default';
      }
      if (this.error) {
        return 'tw-bg-nc-bg-input tw-border-nc-danger tw-text-nc-text tw-shadow-nc-sm focus:tw-ring-1 focus:tw-ring-nc-danger';
      }
      return 'tw-bg-nc-bg-input tw-border-nc-border tw-text-nc-text tw-shadow-nc-sm focus:tw-border-nc-primary focus:tw-ring-1 focus:tw-ring-nc-primary';
    },
  },
};
</script>
